export default __webpack_public_path__ + "static/media/5.21c43f2c.jpeg";